import React from "react";
import Hero from "@/components/Hero";
import Ribbon from "@/components/Ribbon";
import Manifesto from "@/components/Manifesto";
import RecommendationsTeaser from "@/components/RecommendationsTeaser";

export default function HomePage() {
  return (
    <div data-testid="page-home">
      <Hero />
      <Ribbon />
      <Manifesto />
      <RecommendationsTeaser />
    </div>
  );
}
